<div class="cipafacil-horizontal-navigation-wrapper">

    <ng-container *ngFor="let item of navigation">

        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

            <!-- Basic -->
            <cipafacil-horizontal-navigation-basic-item
                class="cipafacil-horizontal-navigation-menu-item"
                *ngIf="item.type === 'basic'"
                [item]="item"
                [name]="name"></cipafacil-horizontal-navigation-basic-item>

            <!-- Branch: aside, collapsable, group -->
            <cipafacil-horizontal-navigation-branch-item
                class="cipafacil-horizontal-navigation-menu-item"
                *ngIf="item.type === 'aside' || item.type === 'collapsable' || item.type === 'group'"
                [item]="item"
                [name]="name"></cipafacil-horizontal-navigation-branch-item>

            <!-- Spacer -->
            <cipafacil-horizontal-navigation-spacer-item
                class="cipafacil-horizontal-navigation-menu-item"
                *ngIf="item.type === 'spacer'"
                [item]="item"
                [name]="name"></cipafacil-horizontal-navigation-spacer-item>

        </ng-container>

    </ng-container>

</div>
